import { ButtonProps } from '../Button';

export const getIconSize = (size: NonNullable<ButtonProps['size']>) => {
    switch (size) {
        case 'small':
            return 12;
        case 'medium':
            return 16;
    }
};
